module.exports = __webpack_public_path__ + "static/media/event-image-alt.cd0b29ed.png";